<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4a20 20 0 1020 20A20 20 0 0024 4zm7.55 25.43A1.5 1.5 0 0130.49 32a1.51 1.51 0 01-1.06-.44L24 26.14l-5.44 5.43a1.49 1.49 0 01-1.06.44 1.53 1.53 0 01-1.06-.44 1.51 1.51 0 010-2.12L21.9 24l-5.45-5.45a1.5 1.5 0 112.12-2.12L24 21.89l5.43-5.43a1.5 1.5 0 012.12 2.12L26.14 24z"/></svg>